import { ProjectStatus } from '../../common/project-status';
import { IInstallationSiteOverviewModel, InstallationSiteOverviewModel } from './installation-site-overview-model';
import { IMaterialCallout, MaterialCallout } from '../../common/material-callout';

export interface IProjectOverviewModel {
    id: string;
    customer: string;
    catalogCode: string;
    address: string;
    status: ProjectStatus;
    assessmentPerformed: number;
    installationScheduled: number;
    installationPerformed: number;
    commuteTimeBlocks: number;
    workAreas: IInstallationSiteOverviewModel[];
    notes: string;
    materials: IMaterialCallout[];
}


export class ProjectOverviewModel implements IProjectOverviewModel {
    public id: string = '';
    public customer: string = '';
    public catalogCode: string = '';
    public address: string = '';
    public status: ProjectStatus = ProjectStatus.Indeterminate;
    public assessmentPerformed: number = 0;
    public installationScheduled: number = 0;
    public installationPerformed: number = 0;
    public commuteTimeBlocks: number = 0;
    public workAreas: IInstallationSiteOverviewModel[] = [];
    public notes: string = '';
    public materials: IMaterialCallout[] = [];
}


